module.exports = __webpack_public_path__ + "img/Lim.b05b185a.jpg";